import React from 'react';
import ReactDOM from 'react-dom';
import propTypes from 'prop-types';
import Popup from '../Popup';

import './style.css';


ActionSheet.propTypes = {
  title: propTypes.node,
  options: propTypes.array.isRequired,
  cancelIndex: propTypes.number,
  destroyIndex: propTypes.number,
  callback: propTypes.func.isRequired
};


function ActionSheet(props) {
  let {
    title,
    options,
    cancelIndex,
    destroyIndex,
    callback,
    className,
    ...reset
  } = props;
  className = `${className} action-sheet`;
  typeof cancelIndex === 'undefined' && (cancelIndex = options.length - 1);

  return (
    <div className={className} {...reset}>
      {title ? (<header>{title}</header>) : null}
      <ol>{options.map((content, index) => {
        return (
          <Button
            key={index}
            index={index}
            cancel={cancelIndex === index}
            destroy={destroyIndex === index}
            callback={callback}>
            {content}
          </Button>
        );
      })}</ol>
    </div>
  );
}


Button.propTypes = {
  index: propTypes.number.isRequired,
  children: propTypes.node.isRequired,
  cancel: propTypes.bool,
  destroy: propTypes.bool,
  callback: propTypes.func.isRequired
};

function Button(props) {
  let {index, children, cancel, destroy, callback} = props;
  let className = 'action-sheet-item';
  cancel && (className = `${className} action-sheet-item-cancel`);
  destroy && (className = `${className} action-sheet-item-destroy`);

  return (
    <li className={className} onClick={() => callback(index)}>
      <button>{children}</button>
    </li>
  );
}



class ActionSheetContainer extends React.Component {
  state = {
    props: {
      options: [],
      callback: () => {}
    },
    popupProps: {
      visible: false
    }
  };

  render() {
    let {props, popupProps} = this.state;

    return (
      <Popup {...popupProps}>
        <ActionSheet {...props} />
      </Popup>
    );
  }

  show(props, popupProps) {
    props = this._decorateProps(props);

    let nextState = {
      props: {...this.state.props, ...props},
      popupProps: {...this.state.popupProps, ...popupProps, visible: true}
    };

    this.setState(nextState);
  }

  hide() {
    let nextState = {
      ...this.state,
      popupProps: {...this.state.popupProps, visible: false}
    };

    this.setState(nextState);
  }

  _decorateProps(props) {
    let callback = props.callback;
    props.callback = (index) => {
      callback && callback(index);
      this.hide();
    };

    return props;
  }
}


export function show(props, popupProps) {
  let instance = getInstance();

  instance.show(props, popupProps);
}

export function hide() {
  let instance = getInstance();
  instance.hide();
}


function getContainerNode() {
  if (getContainerNode.node) {
    return getContainerNode.node;
  }

  let node = getContainerNode.node = document.createElement('div');
  node.className = 'action-sheet-container';
  document.body.appendChild(node);

  return node;
}

function getInstance() {
  if (getInstance.instance) {
    return getInstance.instance;
  }

  let node = getContainerNode();

  getInstance.instance = ReactDOM.render(<ActionSheetContainer />, node);
  return getInstance.instance;
}



// WEBPACK FOOTER //
// ./src/components/ActionSheet/index.js